var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpaidDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 10.5,
    cy: 33.02,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.788 9.086c0-3.13 2.43-4.56 5.56-4.56h15.66c3.13 0 5.67 2.54 5.67 5.67v20.66c0 3.13-2.54 5.67-5.67 5.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.112 20.279H14.19c-.501 0-.982.183-1.358.515-1.297 1.15-4.352 4.128-5.972 7.941-1.17 2.752-1.008 5.048-1.016 5.206-.03.553.337 3.195 3.425 3.636 1.859.265 4.518.405 6.843.418 2.325-.013 4.984-.152 6.843-.418 3.087-.441 3.454-3.083 3.425-3.636-.008-.157.153-2.454-1.016-5.206-1.62-3.812-4.676-6.79-5.972-7.941a2.04 2.04 0 00-1.358-.515h-1.922z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.721 20.279h4.593c.245 0 .469-.164.586-.427l2.438-5.517c.133-.3.1-.668-.085-.925-.368-.511-1.129-1.157-2.434-.561-1.982.906-1.807 1.697-4.26.461-1.712-.862-2.938.032-3.523.652-.24.254-.299.676-.143 1.014l2.249 4.888c.117.256.339.415.579.415z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaidDocument);
export default __webpack_public_path__ + "static/media/unpaidDocument.070ccac75b566f773055a882700b3da4.svg";
export { ForwardRef as ReactComponent };